// Lib
import chroma from 'chroma-js';

// Utils
import { getPredefinedBackgroundColor } from '../../../common/colors/colorHelper';
import { isHexColorFormat } from '../../../common/colors/colorSpaceUtil';

export const isLightColor = (color) => {
    if (!color) return false;

    const colorHex = isHexColorFormat(color) ? color : getPredefinedBackgroundColor(color)?.hex || '#ffffff';

    // calculate expected contrast ratio of light text or dark text
    const contrastDarkText = chroma.contrast('#3d4554', colorHex);
    const contrastLightText = chroma.contrast('#ffffff', colorHex);

    // then use the highest contrast version
    return contrastDarkText > contrastLightText;
};

export const getBackgroundColorClasses = (backgroundColor) => {
    if (!backgroundColor) return;

    // then use the highest contrast version
    const isLightBackground = isLightColor(backgroundColor);

    return {
        'colored-background': true,
        'colored-background-light': isLightBackground,
        'colored-background-dark': !isLightBackground,
    };
};
